module.exports = __webpack_public_path__ + "assets/img/prize_1.45fa4e3b.png";